import { ThemeInput } from "components/components";

const FreeTrial = () => {
  return (
    <div className="bg-themeGray-light200 p-3 -mt-4 -ml-2 min-h-[70vh] desktop:h-[76vh] bigDesktop:h-[83vh]">
      <div className="bg-white p-3 shadow-md">
        <ThemeInput placeholder={"Trial Period (Day(s))"} noRequired />
        <ThemeInput placeholder={"Notification Before Days"} noRequired />
      </div>
    </div>
  );
};

export default FreeTrial;
